import { AddInscriptionModalTitles } from 'routes/BudgetModule/components/shared/InscriptionsGrid/AddInscription/types';
import { InscriptionT } from 'routes/BudgetModule//shared/entities/inscription';
import { budgetCurrencyFormatter } from 'ui/AgGridReact/formatters';
import { getClientBind } from 'store/APIClient';
import {
    PHASE_AMOUNT,
    PHASE_COMMENT,
} from 'routes/BudgetModule/config/constants';
import { isAmp } from 'routes/BudgetModule/helpers/bind';

export const getMoveInscriptionStepTitles = (
    t: TranslationT,
    resourceName: string,
): AddInscriptionModalTitles => {
    const resourceNameLower = resourceName.toLowerCase();
    const bind = getClientBind();
    return {
        budgetProposalSelection: {
            title: t('moveInscriptionModal.budgetProposalSelectionTitle', {
                dimension: `${resourceNameLower}`,
            }),
            subTitle: t(
                'moveInscriptionModal.budgetProposalSelectionSubtitle',
                {
                    dimension: `${resourceNameLower}`,
                    gender: isAmp(bind) ? 'auxquelles' : 'auxquels',
                },
            ),
        },
        budgetLineSelection: {
            title: t('moveInscriptionModal.budgetLineSelectionTitle'),

            subTitle: t('moveInscriptionModal.budgetLineSelectionSubtitle'),
        },
    };
};

export const getMoveInscriptionSubtitle = (
    t: TranslationT,
    selectedInscription: InscriptionT,
): string => {
    const amount = budgetCurrencyFormatter({
        value: selectedInscription[PHASE_AMOUNT],
    });
    const comment = selectedInscription[PHASE_COMMENT];
    let subtitle = '';
    if (amount) {
        const inscriptionDescription =
            comment && comment !== 'unknown' ? `${amount}, ${comment}` : amount;

        subtitle = `${t(
            'moveInscriptionModal.inscriptionToMove',
        )}: ${inscriptionDescription}`;
    }
    return subtitle;
};
